export default [
    {
       path: "/movie",
       name: "Movie",
       meta: {
         title: "电影",
         keepAlive: true,
         footer: false,
         movieFooter: true,
         home:false,
         backgroundColor: "#fff"
      },
       component: ()=>import ("@views/movie/Movie.vue")
    }, {
        path: "/cinemas",
        name: "Cinemas",
        meta: {
            title: "影院",
            keepAlive: true,
            footer: false,
            movieFooter: true,
            home:false,
            backgroundColor: "#fff"
        },
       component: ()=>import ("@views/movie/Cinemas.vue")
    },{
        path: "/movieOrder/:id",
        name: "MovieOrder",
        meta: {
            title: "订单",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            // movieFooter: true,底部导航
            home:false,
            auth: true
        },
       component: ()=>import ("@views/movie/MovieOrder.vue")
    },{
        path:"/movieDetails",
        name:"MovieDetails",
        meta: {
            title: "电影详情",
            keepAlive: true,
            footer: false,
            movieFooter: false,
            home:false,
            backgroundColor: "#fff"
        },
        component: ()=>import ("@views/movie/MovieDetails.vue")
    }, {
        path:"/chooseCinema",
        name:"ChooseCinema",
        meta: {
            title: "选择购票影院",
            keepAlive: true,
            footer: false,
            movieFooter: false,
            home:false,
            backgroundColor: "#fff"
        },
        component: ()=>import ("@views/movie/ChooseCinema.vue")
    }, {
        path:"/cinemasDetails",
        name:"CinemasDetails",
        meta: {
            title: "影院详情",
            keepAlive: true,
            footer: false,
            movieFooter: false,
            home:false,
            backgroundColor: "#fff"
        },
        component: ()=>import ("@views/movie/CinemasDetails.vue")
    }, {
        path:"/seatSelection",
        name:"SeatSelection",
        meta: {
            title: "座位选择",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false,
            backgroundColor: "#fff"
        },
        component: ()=>import ("@views/movie/SeatSelection.vue")
    }, {
        path:"/confirmOrder",
        name:"ConfirmOrder",
        meta: {
            title: "确认订单",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false,
            backgroundColor: "#fff",
            auth: true
        },
        component: ()=>import ("@views/movie/ConfirmOrder.vue")
    }, 
    // 老电影支付页
    {
        path:"/paymentResult",
        name:"PaymentResult",
        meta: {
            title: "支付页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component: ()=>import ("@views/movie/PaymentResult.vue")
    },
     {
        path:"/movieTicketDetails/:id",
        name:"MovieTicketDetails",
        meta: {
            title: "电影票详情页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:true,
            backgroundColor: "#fff",
            auth: true
        },
        component: ()=>import ("@views/movie/MovieTicketDetails.vue")
    },
    {
        path:'/xuanKuaDetail/:id',
        name:'xuanKuaDetail',
        meta:{
            title:'电影票详情',
            keepAlive:false,
            footer:false,
            movieFooter:false,
            home:true,
            backgroundColor:"#fff",
            auth:true
        },
        component:()=>import("@views/movie/xuanKuaDetail.vue")
    },
    {
        //轩夸电影支付页
        path:`/xuanKuaPaymentResult`,
        name:'xuanKuaPaymentResult',
        meta: {
            title: "支付页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component:()=>import("@/views/movie/XuanKuaPaymentResult.vue")
    },

    {
        //轩夸演出支付页
        path:`/xuanKuaYcPayment`,
        name:'xuanKuaYcPayment',
        meta: {
            title: "支付页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component:()=>import("@/components/XuanKuaYcPayment.vue")
    },
    {
        //演出详情
        path:`/xuanKuaYcPayDetail/:id`,
        name:'xuanKuaYcPayDetail',
        meta: {
            title: "演出详情",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component:()=>import("@/views/movie/XkYcPayDetail.vue")
    },
    {
        //轩夸演出订单
        path: "/xkYcOrderList/:id",
        name: "xkYcOrderList",
        meta: {
            title: "订单列表",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false,
            auth: false
        },
       component: ()=>import ("@views/movie/xuankuaYcList.vue")
    }
];
